export default __webpack_public_path__ + "static/media/winner9.d406636f.jpg";